<app-configuration-page
  title="Square"
  description="Authorize your Square account to take card payments, then choose the location this studio uses."
  [breadcrumbs]="[{ label: 'Integrations' }, { label: 'Square' }]">

  <div class="row">
    <!-- Main column: settings + devices -->
    <div class="col-lg-8 col-12 square-main-col">
      <app-form-square-settings></app-form-square-settings>
      <app-square-connected-devices></app-square-connected-devices>
    </div>

    <!-- Sidebar: setup guide -->
    <div class="col-lg-4 col-12">
      <app-setup-guide
        heading="Connecting your account"
        [steps]="setupSteps">
      </app-setup-guide>
    </div>
  </div>

</app-configuration-page>
